import React from 'react';

import { Center, Divider, Group, Text } from '@mantine/core';
import HelpButton from 'components/HelpButton';
import { EstimatedSessionsResult } from 'utils/billing.helpers';

interface IEstimatedSessionsBadgeProps {
  result: EstimatedSessionsResult;
}

const getLabel = (result: EstimatedSessionsResult): string => {
  if (result.warning) return result.warning;
  if (result.isEstimate) return `${result.sessions} Estimated Sessions`;
  return `${result.sessions} Sessions`;
};

const EstimatedSessionsBadge = ({ result }: IEstimatedSessionsBadgeProps): JSX.Element | null => {
  if (result.sessions === null && !result.warning) return null;

  const label = getLabel(result);

  return (
    <>
      <Divider />
      <Group p='sm' align='left'>
        <Center>
          <Text size='xs'>{label}</Text>
        </Center>
        <HelpButton width={500} position='right'>
          <Text size='sm'>
            Estimated sessions are calculated based on the validity period of the attendance rule.
          </Text>
        </HelpButton>
      </Group>
    </>
  );
};

export default EstimatedSessionsBadge;
